module.exports = __webpack_public_path__ + "media/images/top-list-b297813555cf0db461f81cf3c374640c.png";